var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"configuration-card",class:_vm.color},[_c('div',{staticClass:"content"},[_c('h3',{staticClass:"first-line"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"second-line"},[_vm._v(_vm._s(_vm.description))])]),_c('div',{staticClass:"number"},[_vm._v(" "+_vm._s(_vm.stepNumber)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }